import { QueryClient } from '@tanstack/react-query'

/**
 * Default TanStack Query client.
 * - 30s `staleTime` so navigating between role dashboards doesn't thrash the API.
 * - Retry once on transient failure; let `ApiError`s with 4xx codes bubble.
 * - Refetch on reconnect so an actor returning from offline sees fresh state.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
})
